import { Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges, ViewEncapsulation } from '@angular/core';

@Component({
  selector: 'app-documents-tree',
  templateUrl: './documents-tree.component.html',
  styleUrls: ['./documents-tree.component.css'],
  encapsulation: ViewEncapsulation.None
})
export class DocumentsTreeComponent implements OnInit, OnChanges {
  @Input() folders: any[];
  @Input() isJobMatchFolders: boolean;
  @Input() isAvailableDocuments: boolean;
  @Input() availableDocumentsInFolders: any[];
  @Input() customStyle: string;

  @Output() onSelectFolder = new EventEmitter<any>();
  @Output() onAddFolder = new EventEmitter<any>();
  @Output() onEditFolder = new EventEmitter<any>();
  @Output() onDeleteFolder = new EventEmitter<any>();
  @Output() onMoveFolder = new EventEmitter<any>();
  @Output() onSelectFolderWithDocuments = new EventEmitter<any>();
  @Output() onSelectAndDeselectDocument = new EventEmitter<any>();

  isJobMatchDocumentsAvailable = false;
  isCandidateDocumentsAvailable = false;
  private onDataChangeCount = 1;

  ngOnInit() {
    this.isJobMatchDocumentsAvailable = false;
    this.isCandidateDocumentsAvailable = false;
    this.onDataChangeCount = 1;
    this._setDocumentTreeFolderVisibility();
    this._setCandidateDocuments();
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes && changes.folders && this.onDataChangeCount > 0) {
      setTimeout(() => {
        this._setDocumentTreeFolderVisibility();
        this._setCandidateDocuments();
      }, 100);
      this.onDataChangeCount += 1;
    }
  }

  visible(item: any): boolean {
    return true;
  }

  addFolder(folder?: any) {
    this.onAddFolder.emit(folder ? { parentFolder: folder } : {});
  }

  editFolder(folder: any) {
    this.onEditFolder.emit({ folder });
  }

  deleteFolder(folder: any) {
    this.onDeleteFolder.emit({ folder });
  }

  moveFolder(folder: any) {
    this.onMoveFolder.emit({ folder });
  }

  selectFolderWithDocuments(folder: any) {
    folder.isJobMatchFolders = this.isJobMatchFolders;
    this.onSelectFolderWithDocuments.emit({ folder });
  }

  selectAndDeselectDocument(event: { document: any, folder: any }) {
    this.onSelectAndDeselectDocument.emit(event);
  }

  selectFolder(event: { folder: any, type: string }) {
    if (event.type !== 'fromDocumentSelect') {
      this._resetSelectedCandidateDocuments();
    }
    event.folder.isJobMatchFolders = this.isJobMatchFolders;
    this.onSelectFolder.emit({ selectedFolder: event.folder });
  }

  onDocumentSelect(event: { document: any, folder: any }) {
    if (!this.isAvailableDocuments) {
      this._resetSelectedCandidateDocuments();
      event.document.isDocumentSelected = true;
      this.selectFolder({ folder: event.folder, type: 'fromDocumentSelect' });
    }
  }

  private _setCandidateDocuments() {
    if (this.availableDocumentsInFolders && this.availableDocumentsInFolders.length > 0) {
      this.availableDocumentsInFolders.every(document => {
        if (!document.isJobMatchDocument) {
          this.isCandidateDocumentsAvailable = true;
          return false;
        }
        return true;
      });
    }
  }

  private _setDocumentTreeFolderVisibility() {
    if (this.folders && this.folders.length > 0) {
      this.folders.map(parentFolder => {
        if (parentFolder.documents.length > 0) {
          parentFolder.showParentFolder = true;
          this.isJobMatchDocumentsAvailable = true;
        } else {
          parentFolder.showParentFolder = false;
        }
        parentFolder.showActions = false;
        if (parentFolder.folders && parentFolder.folders.length > 0) {
          parentFolder.folders.map(childFolder => {
            childFolder.showChildFolder = childFolder.documents.length > 0;
            childFolder.showActions = false;
            if (childFolder.showChildFolder) {
              parentFolder.showParentFolder = true;
            }
          });
        }
      });
    }
  }

  private _resetSelectedCandidateDocuments() {
    if (this.folders && this.folders.length > 0) {
      this.folders.map(parentFolder => {
        if (parentFolder.documents.length > 0) {
          parentFolder.documents.map(doc => doc.isDocumentSelected = false);
        }
        if (parentFolder.folders && parentFolder.folders.length > 0) {
          parentFolder.folders.map(childFolder => {
            if (childFolder.documents.length > 0) {
              childFolder.documents.map(doc => doc.isDocumentSelected = false);
            }
          });
        }
      });
    }
  }
}
